import React, { useState } from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { selectOnFocus, parseNum } from "../../lib/inputHelpers";

// v6 E6 — numeric field with comma OR dot decimal input.
//   - During editing, the input keeps the RAW string the user typed (draft state)
//     so a Belgian user typing "1,5" sees "1,5" without re-format jitter.
//   - onBlur clears the draft and the field reverts to the controlled parsed value.
//   - Parent always receives a normalized Number via parseNum.
//   - Mobile shows decimal keyboard via inputMode="decimal".
export default function NumF({ label, value, onChange, step = "0.01", testId, placeholder, allowEmpty, compact }) {
  const [draft, setDraft] = useState(null);
  const display = draft !== null
    ? draft
    : (value === null || value === undefined ? "" : value);
  return (
    <div className={compact ? "w-20 sm:w-24 min-w-0" : ""}>
      {label !== undefined && label !== null && <Label className="text-xs">{label}</Label>}
      <Input
        type="text"
        inputMode="decimal"
        pattern="[0-9.,]*"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        step={step}
        value={display}
        placeholder={placeholder}
        onFocus={(ev) => { setDraft(value === null || value === undefined ? "" : String(value)); selectOnFocus(ev); }}
        onChange={(ev) => {
          const raw = ev.target.value;
          setDraft(raw);
          if (allowEmpty && raw === "") return onChange("");
          onChange(parseNum(raw));
        }}
        onBlur={() => setDraft(null)}
        className={compact && (label === undefined || label === null)
          ? "h-8 rounded-md font-mono text-xs flex-1 min-w-0"
          : "h-11 mt-1 rounded-lg font-mono text-sm"}
        data-testid={testId}
      />
    </div>
  );
}
